<template>
  <v-fade-transition>
    <AppBody title="Status da API" subtitle="Status" class="pa-5">
      <v-container>
        <p>
          Version: <strong>{{ status.version }}</strong>
        </p>
        <p>
          Status do servidor:
          <strong>{{ status.server_status }}</strong>
          <v-badge
            class="ml-3"
            color="green"
            v-if="status.server_status == 'on'"
          ></v-badge>
          <v-badge class="ml-3" color="red" v-else></v-badge>
        </p>
        <p
          v-for="(dbs, index) in db"
          :key="index"
          :value="dbs"
          v-show="index == 0"
        >
          DB Status:
          <strong>{{ dbs.status }}</strong>
          <v-badge
            class="ml-3"
            color="green"
            v-if="dbs.status == 'on'"
          ></v-badge>
          <v-badge class="ml-3" color="red" v-else></v-badge>
        </p>
      </v-container>
      <div class="ChainContainer d-flex justify-center">
        <p class="cache font-weight-bold">ChainCache</p>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <div class="info-tool" v-bind="attrs" v-on="on">
              <svg viewBox="0 0 1024 1024" class="info-tool-icon">
                <path
                  d="M470 384v-86h84v86h-84zM512 854q140 0 241-101t101-241-101-241-241-101-241 101-101 241 101 241 241 101zM512 86q176 0 301 125t125 301-125 301-301 125-301-125-125-301 125-301 301-125zM470 726v-256h84v256h-84z"
                ></path>
              </svg>
            </div>
          </template>
          <span>{{ infoMessage }}</span>
        </v-tooltip>
      </div>
      <v-container class="pa-0 pb-10">
        <p
          v-for="(ups, index) in cache.ChainCache"
          :key="index"
          :value="ups"
          v-show="index == 0"
        >
          Uptime: <strong>{{ ups.uptime }} - {{ ups.status }}</strong>
          <v-badge
            class="ml-3"
            color="green"
            v-if="ups.status == 'on'"
          ></v-badge>
          <v-badge class="ml-3" color="red" v-else></v-badge>
        </p>
      </v-container>
    </AppBody>
  </v-fade-transition>
</template>

<script>
export default {
  name: "StatusAPI",
  metaInfo: {
    title: "StatusAPI | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "StatusAPI | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      status: "",
      cache: [{ ChainCache: [] }],
      db: [],
      infoMessage: "Caches que estão rodando na API",
    };
  },
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
  },
  mounted() {
    this.$axios
      .get(process.env.VUE_APP_BASE_URL + "check/status")
      .then(response => {
        this.status = response;
        this.cache = response.cache;
        this.db = response.db;
      });
  },
};
</script>
<style scoped>
strong {
  text-transform: uppercase;
}
.ChainContainer {
  width: 100%;
  position: relative;
}
.cache {
  width: 100% !important;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-color: var(--dl-color-gray-black);
  border-width: 0.064rem;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0.125rem;
}
.info-tool {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50px;
  cursor: pointer;
  position: absolute;
  left: 0;
  margin-left: 6.3rem;
  margin-top: 0.685rem;
}

.info-tool-icon {
  fill: #000;
  height: 24px;
  width: 24px;
}
</style>
